import { getApiCaller } from "../apiCaller";

export const getAllChat = async (page, limit) => {
    const response = await getApiCaller(`session/get-all?page=${page}&limit=${limit}`);
    return response;
}

